import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { type IWidgetCardLayoutProps, WidgetCardLayout } from "./WidgetCardLayout";

export const ErrorFallback = ({ actions: _actions, ...other }: IWidgetCardLayoutProps) => {
    const translate = useTranslation();

    return (
        <WidgetCardLayout {...other}>
            <Flex
                justifyContent="center"
                flexGrow="1"
                height="100%"
            >
                <EmptyState
                    title={translate("error.boundary.title")}
                    subtitle={translate("error.boundary.subtitle")}
                    CtaButtons={undefined}
                    iconName="no-data-tree"
                />
            </Flex>
        </WidgetCardLayout>
    );
};
